import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Subscription Plans</Typography>
      <p>If you are on out FREE tier or one of our pay-as-you-go plans then you'll see details
        of your current plan, details of our other tiers and pricing.
      </p>

      <p>You can change plan at any time, either upgrading or downgrading. You can also
        apply for our monthly contract plan. If you are already on that plan, and you wish to
        revert to one of our pay-as-you-go plans then please raise a support request.
      </p>

      <Typography variant='h5' className='pb-5'>Upgrading your plan</Typography>
      <p>Upgrade are applied immediately. You pay the difference between your current plan
        and the new plan. If you are upgrading from the FREE Tier then your new billing period
        will begin immediately.     
      </p>

      <Typography variant='h5' className='pb-5'>Downgrading your plan</Typography>
      <p>Downgrades are applied at the start of your next billing period, so you continue to
        have the full use of the pass limits you paid for until then.  
      </p>

      <p>It is your responsibility to ensure that you reduce your active pass count to
        a level that is covered by your new plan. If you have too many active passes for 
        the requested plan then we wil be unable to proceed your downgrade request.
      </p>

      <p>However, if we we move you to a lower plan that does support your number of 
        active passes then we wil do so.
      </p>

      <p>For example, you are on our <b>Medium</b> tier which allows 600 active passes. You request a
      downgrade to our <b>Micro</b> tier which includes 100 active passes. However, at the start of 
      your next billing period you have 150 active passes. So we cannot move you to the Micro tier. 
      However, the <b>Small</b> tier will will allow upto 250 passes. We will downgrade you from the
      <b>Medium</b> to the <b>Small</b> tier.</p>

      <p>If you wish to downgrade to Micro the following month then you should request a new downgrade
        and ensure active passes are sufficiently reduced before your next billing period.
      </p>

    </div>
  )
}

export default HelpText